import React from 'react'
// import {Link} from 'react-router-dom'
// import {KTSVG} from '../../../../_gori/helpers'
// import {TermsModal} from '../../orders/modals/TermsModal'
// import {useIntl} from 'react-intl'
// import {ROUTES} from '../../../../_gori/constants/_routes'
// import {MARKET_PROMO_AMOUNT} from '../../../../_gori/constants/_const'

interface BannerContent {
  iconPath: string
  highlightTextKey: string
  titleKey: string
  descriptionLine1Key: string
  descriptionLine2Key: string
  helpTextKey: string
  helpLinkKey: string
  termsLinkKey: string
  appliedTitleKey: string
  appliedDescriptionKey: string
  appliedIconPath?: string
  underlineIconPath?: string
  onTermsClick?: () => void
  helpLinkTo: string
}

interface PromotionBannerProps {
  isEligible?: boolean
  isApplied?: boolean
  content?: Partial<BannerContent>
}

const PromotionBanner: React.FC<PromotionBannerProps> = ({
  isEligible = false,
  isApplied = false,
  content,
}) => {
  // Temporarily hidden due to fraud — remove `return null` and uncomment below to re-enable
  return null
  /* eslint-disable */
  /*
  const intl = useIntl()
  const [showTermsModal, setShowTermsModal] = React.useState(false)

  // Default content (legacy support)
  const defaultContent: BannerContent = {
    iconPath: '/media/gori/promotions/MarketPromoShopIcon.svg',
    highlightTextKey: 'MARKETPLACE_PROMOTION_ASIDE_FIFTY',
    titleKey: 'MARKETPLACE_PROMOTION_ASIDE_TITLE',
    descriptionLine1Key: 'MARKETPLACE_PROMOTION_ASIDE_TEXT_1',
    descriptionLine2Key: 'MARKETPLACE_PROMOTION_ASIDE_TEXT_2',
    helpTextKey: 'MARKETPLACE_PROMOTION_ASIDE_TEXT_3',
    helpLinkKey: 'MARKETPLACE_PROMOTION_ASIDE_TEXT_4',
    termsLinkKey: 'MARKETPLACE_PROMOTION_ASIDE_SEETERM',
    appliedTitleKey: 'PROMOAPPLIED_TITLE',
    appliedDescriptionKey: 'PROMOAPPLIED_TEXT',
    appliedIconPath: '/media/gori/promotions/Star.svg',
    underlineIconPath: '/media/gori/promotions/CarouselUnderline.svg',
    helpLinkTo: ROUTES.HELP_CENTER.BASE,
  }

  const bannerContent = content ? {...defaultContent, ...content} : defaultContent

  const handleTermsClick = () => {
    if (bannerContent.onTermsClick) {
      bannerContent.onTermsClick()
    } else {
      setShowTermsModal(true)
    }
  }

  const handleCloseTerms = () => {
    setShowTermsModal(false)
  }

  if (!isEligible && !isApplied) {
    return null
  }

  // If the promotion is not applied, show the banner
  return !isApplied ? (
    <>
      <div className='promotion-banner'>
        <div className='promotion-banner__header'>
          <div className='promotion-banner__illustrations'>
            <KTSVG
              path={bannerContent.iconPath}
              svgClassName='promotion-banner__main-icon'
              small={false}
            />
          </div>
        </div>
        <div className='promotion-banner__content'>
          <div className='promotion-banner__text'>
            <div className='promotion-banner__headline'>
              <span className='promotion-banner__highlight'>
                {intl.formatMessage(
                  {id: bannerContent.highlightTextKey},
                  {amount: MARKET_PROMO_AMOUNT}
                )}
              </span>
              <span className='promotion-banner__subtitle'>
                {intl.formatMessage({id: bannerContent.titleKey})}
              </span>
            </div>
            <div className='promotion-banner__description'>
              {intl.formatMessage({id: bannerContent.descriptionLine1Key})}
              <br />
              {intl.formatMessage({id: bannerContent.descriptionLine2Key})}
            </div>
          </div>
          <div className='promotion-banner__help-text'>
            {intl.formatMessage({id: bannerContent.helpTextKey})}{' '}
            <Link to={bannerContent.helpLinkTo} className='promotion-banner__help-link'>
              {intl.formatMessage({id: bannerContent.helpLinkKey})}
            </Link>
          </div>
          <div className='promotion-banner__terms'>
            <span className='promotion-banner__terms-link' onClick={handleTermsClick}>
              {intl.formatMessage({id: bannerContent.termsLinkKey})}
            </span>
          </div>
        </div>
      </div>
      <TermsModal show={showTermsModal} handleClose={handleCloseTerms} />
    </>
  ) : (
    <div className='applied_promo'>
      <div className='applied_content'>
        <div className='applied_text'>
          <KTSVG
            path={bannerContent.appliedIconPath || '/media/gori/promotions/Star.svg'}
            small={true}
          />
          <span>{intl.formatMessage({id: bannerContent.appliedTitleKey})}</span>
        </div>
        <div className='applied_text_description'>
          {intl.formatMessage(
            {id: bannerContent.appliedDescriptionKey},
            {amount: MARKET_PROMO_AMOUNT}
          )}
        </div>
      </div>
    </div>
  )
  */
}

export {PromotionBanner}
export type {BannerContent}
